import React from 'react';
import EmojiPicker from 'emoji-picker-react';
import PropTypes from 'prop-types';
import useKeyboardNavigation from '@/shared/hooks/useKeyboardNavigation';

export const Emoji = ({ onEmojiClick, id, activeId, emojiState = true, handleCloseEmojiClick = () => {} }) => {
   const isVisible = id && activeId !== undefined ? id === activeId : emojiState;

   const keyboardConfig = React.useMemo(() => ({ Escape: handleCloseEmojiClick }), [handleCloseEmojiClick]);
   useKeyboardNavigation(keyboardConfig, { enabled: isVisible });

   const addEmoji = emojiData => {
      const emoji = emojiData?.emoji;
      if (emoji) onEmojiClick(emoji);
   };

   if (!isVisible) return null;

   return (
      <div className="emojiPicker-container">
         <EmojiPicker
            className="emoji_picker"
            width={'100%'}
            onEmojiClick={addEmoji}
            autoFocusSearch={false}
            previewConfig={{ showPreview: false }}
         />
      </div>
   );
};

Emoji.propTypes = {
   onEmojiClick: PropTypes.func,
   id: PropTypes.string,
   activeId: PropTypes.string,
   emojiState: PropTypes.bool,
   handleCloseEmojiClick: PropTypes.func,
};
